module.exports = __webpack_public_path__ + "img/pil_yes.42edbcbf.png";